import $ from "jquery";
import { transformWindowCoordinateToCanvasCoord } from './calc'
import startImage from "../../assets/img/ic_pin_mapa.webp"
import endImage from "../../assets/img/ic_ubicacion_actual.webp"
import stairsImage from "../../assets/img/ic_escalera.webp"

export const drawStartIcon = (x, y, w, h, zIndex, title) => {
 draw(x, y, w, h, startImage, 'startIcon', 'start-image', zIndex, title)
}

export const removeStartIcon = () => {
  $('#startIcon').remove();
}

export const drawEndIcon = (x, y, w, h, zIndex, title) => {
  draw(x, y, w, h, endImage, 'endIcon', 'end-image', zIndex, title)
}

export const removeEndIcon = () => {
  $('#endIcon').remove();
}

export const drawStairsIcon = (x, y, w, h, zIndex, title) => {
  draw(x, y, w, h, stairsImage, 'stairsIcon', 'start-image', zIndex, title)
}

export const removeStairsIcon = () => {
  $('#stairsIcon').remove();
  $('#stairsIcon').remove();
}

export const drawServiceIcon = (x, y, w, h, icon, zIndex, title) => {
  draw(x, y, w, h, icon, 'serviceIcon', 'start-image', zIndex, title);
}

export const removeServiceIcon = () => {
  $('#serviceIcon').remove();
}

function draw(x, y, w, h, image, id, cssClass, zIndex = 150, title = '') {
  let trans = transformWindowCoordinateToCanvasCoord(x, y, w, h);
  let tooltip = '';
  if (title) {
    tooltip = `<span style="
      position: absolute;
      top: ${id === 'endIcon' ? -45 : -70}px;
      left: 50%;
      transform: translateX(-50%);
      background: #ffffff;
      color: #e6144f;
      padding: 4px 8px;
      border: 1px solid #e6144f;
      border-radius: 4px;
      font-size: 12px;
      white-space: nowrap;
      z-index: ${zIndex + 1};
      pointer-events: none;
      ">${title}</span>`;
  }
  $('#iconsContainer').prepend(
    `<div id="${id}" style="position: absolute; top:${trans.y}px; left:${trans.x}px; z-index:${zIndex};">
      <img src="${image}" class="canvas-anim-img ${cssClass}" style="z-index: ${zIndex};"/>
      ${tooltip}
    </div>`
  );
}


// WEBPACK FOOTER //
// ./src/utils/cssAnimator.js